// extracted by mini-css-extract-plugin
module.exports = {"body":"popoverError_body__HjXY7"};